// extracted by mini-css-extract-plugin
export default {"colorMarker":"ColorMarker_colorMarker__5WWYi"};